export default "__VITE_ASSET__bHXMB5OZ__"